export const config = {
  title: 'Elevate your business to the Cloud',
  buttonText: 'Get matched',
}
